import React, { useEffect, useState } from "react";
import imageCompression from "browser-image-compression";
import Layout from "../../components/Layout";
import "./EditQrCode.css";
import {
  Collapse,
  Form,
  Button,
  Space,
  Row,
  Col,
  Input,
  Upload,
  Modal,
  message,
  Image,
  Slider,
  Radio,
  Switch,
  Checkbox,
} from "antd";
import { useDebouncedCallback } from "use-debounce";
import shortId from "shortid";
import {
  RiBehanceFill,
  RiFacebookBoxFill,
  RiInstagramFill,
  RiLinkedinBoxFill,
  RiMailFill,
  RiMap2Fill,
  RiSkypeFill,
  RiTelegramFill,
  RiTwitterFill,
  RiWhatsappFill,
  RiYoutubeFill,
  RiSnapchatFill,
} from "react-icons/ri";
import ReactQuill from "react-quill";
import { FiExternalLink } from "react-icons/fi";
import { CgColorPicker } from "react-icons/cg";
import { FaTiktok } from "react-icons/fa";
import {
  DoubleRightOutlined,
  PlusOutlined,
  LinkOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { BiCommentError } from "react-icons/bi";
import { Link, useParams } from "react-router-dom";
import getBase64 from "../../helpers/getBase64";
import { request } from "../../config/API";
import authHeader from "../../redux/services/authHeader";
import { COLORS } from "../../config/theme";
import QRCode from "../../components/QRCode";
import { API, Domain } from "../../config/API";
import PreviewVcard from "../../components/PreviewVcard";
import { SketchPicker } from "react-color";
import { openNotification } from "../../redux/actions/Notification/notifications.action";
import { Helmet } from "react-helmet";
import { loader, profileImgPlaceholder } from "../../assets/images";
import ImgCrop from "antd-img-crop";
import { useSelector } from "react-redux";
import {
  DEVELOPER,
  SUPER_ADMIN,
  SUPER_ADMIN_EDITOR,
  WHITE_LABEL_ADMIN,
  ADMIN,
  SUB_ADMIN,
  ACTING_ADMIN,
  EDITOR_ADMIN,
} from "../../config/roles";
import LocationSearch from "../../components/LocationSearch";
import ProfileButtons from "./Components/ProfileButtons";
import ProfileManagementModal from "./Components/ProfileManagementModal";
import SetupProfileModal from "./Components/SetupProfileModal";
import AddWalletButton from "../../components/AddWalletButton";
import ThemeSlider from "./Components/ThemeSlider";
const iconNames = require("../../helpers/ICONS.json");

const EditQrCode = () => {
  // image upload loading
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  // Error Modal
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [showSetupProfileModal, setShowSetupProfileModal] = useState("");
  const [profileManagementModal, setProfileManagementModal] = useState("");
  const [selectedTheme, setSelectedTheme] = useState(0);
  const { subscribedPlan } = useSelector((state) => state.membership);
  const { role, _id } = useSelector((state) => state.auth.user);
  const { Search } = Input;

  //   hooks
  const { id } = useParams();
  const [form] = Form.useForm();
  const { Panel } = Collapse;
  const { Item } = Form;

  const { primaryDark, primary, danger } = COLORS;

  const [isLoading, setIsLoading] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [qrData, setQrData] = useState([]);

  const [sectionOrder, setSectionOrder] = useState([
    { key: "1", header: "Contact" },
    { key: "2", header: "Web Links" },
    { key: "3", header: "About Us" },
    { key: "4", header: "SCAN QR CODE" },
    { key: "5", header: "Gallery" },
    { key: "6", header: "Gallery" },
  ]);
  const [profiles, setProfiles] = useState([]);
  const [selectedProfileId, setSelectedProfileId] = useState("");

  const controller = new AbortController();
  const { link } = qrData;
  const options = {
    signal: controller.signal,
    maxSizeMB: 1,
  };
  //   helper funstion to hard set initial value in dynamic form
  // const setWebLinks = (websites) => {
  //   form.setFieldsValue({ websites });
  // };
  const setYtLinks = (youtube) => {
    form.setFieldsValue({ youtubelinks: youtube });
  };
  //   helper funstion to hard set social links
  const setFormSocialLinks = (fieldName, value) => {
    form.setFieldsValue({ [fieldName]: value });
  };
  const getQrCode = (id) => {
    setIsLoading(true);
    request
      .get(`/qr/profile/${id}`)
      .then(({ data: { data, profiles } }) => {
        setQrData(data);
        const {
          _id,
          pColor,
          sColor,
          profileImage,
          bgImage,
          fName,
          lName,
          fNamePrefix,
          lNameSuffix,
          address,
          postalAddress,
          mobile,
          mobile2,
          phone,
          phone2,
          summary,
          email,
          jobTitle,
          company,
          webLinks,
          socialLinks,
          images,
          qrSetting,
          youtubeLinks,
          showQr,
          sectionOrder,
          leadEnable,
          contactExchangeHeader,
          selectedContactExchangeOptions,
          selectedTheme,
        } = data;
        setProfiles(profiles);
        setSelectedProfileId(_id);
        const imageList = images.map((img, i) => {
          return {
            uid: shortId(),
            name: img,
            status: "done",
            url: `${Domain}/data/${img}`,
          };
        });
        // colors
        setColors({ primary: pColor, secondary: sColor });
        // profile image
        profileImage && setProfileImage(profileImage);
        profileImage &&
          setProfileImageList([
            {
              uid: shortId(),
              name: profileImage,
              status: "done",
              url: `${Domain}/data/${profileImage}`,
            },
          ]);
        bgImage && setBgImage(bgImage);

        bgImage &&
          setBgImageList([
            {
              uid: shortId(),
              name: bgImage,
              status: "done",
              url: `${Domain}/data/${bgImage}`,
            },
          ]);

        // basic info
        form.setFieldsValue({ fNamePrefix: fNamePrefix });
        form.setFieldsValue({ fName: fName });
        form.setFieldsValue({ lName: lName });
        form.setFieldsValue({ lNameSuffix: lNameSuffix });
        form.setFieldsValue({ email: email });
        form.setFieldsValue({ mobile: mobile });
        form.setFieldsValue({ mobile2: mobile2 });
        form.setFieldsValue({ phone: phone });
        form.setFieldsValue({ phone2: phone2 });
        form.setFieldsValue({ company: company });
        form.setFieldsValue({ jobTitle: jobTitle });
        form.setFieldsValue({ address: address });
        form.setFieldsValue({ postalAddress: postalAddress });
        form.setFieldsValue({ summary: summary });
        setBasicInfo({
          fNamePrefix,
          fName,
          lName,
          lNameSuffix,
          email,
          mobile,
          mobile2,
          phone,
          phone2,
          company,
          jobTitle,
          address,
          postalAddress,
          summary,
        });
        setSelectedTheme(selectedTheme);
        setContactExchangeEnabled(leadEnable);
        setContactExchangeHeader(contactExchangeHeader || "Contact Exchange");
        setSelectedContactExchangeOption(
          selectedContactExchangeOptions.length <= 0
            ? contactExchangeOptionArray
            : selectedContactExchangeOptions
        );
        // Weblinks
        // for setting state
        // setWebLinks(webLinks);
        setYtLinks(youtubeLinks);
        // adding initial values in form
        setWebsites(webLinks);
        setFinalWebSites(webLinks);
        setYoutubeLinks(youtubeLinks);
        // Gallery
        setFileList(imageList);
        //Show Qr In Profile
        setShowQr(showQr);
        // Social Links
        if (sectionOrder.length > 0) {
          setSectionOrder(sectionOrder);
        }
        setSocialLinks(socialLinks);
        socialLinks?.forEach((sLink) => {
          if (sLink?.name === "facebook" && sLink?.link) {
            setIsFacebook(true);
            setFormSocialLinks("facebook", sLink?.link);
          }
          if (sLink?.name === "instagram" && sLink?.link) {
            setIsInstagram(true);
            setFormSocialLinks("instagram", sLink?.link);
          }
          if (sLink?.name === "linkedin" && sLink?.link) {
            setIsLinkedin(true);
            setFormSocialLinks("linkedin", sLink?.link);
          }
          if (sLink?.name === "twitter" && sLink?.link) {
            setIsTwitter(true);
            setFormSocialLinks("twitter", sLink?.link);
          }
          if (sLink?.name === "skype" && sLink?.link) {
            setIsSkype(true);
            setFormSocialLinks("skype", sLink?.link);
          }
          if (sLink?.name === "behance" && sLink?.link) {
            setIsBehance(true);
            setFormSocialLinks("behance", sLink?.link);
          }
          if (sLink?.name === "youtube" && sLink?.link) {
            setIsYoutube(true);
            setFormSocialLinks("youtube", sLink?.link);
          }
          if (sLink?.name === "whatsapp" && sLink?.link) {
            setIsWhatsapp(true);
            setFormSocialLinks("whatsapp", sLink?.link);
          }
          if (sLink?.name === "maps" && sLink?.link) {
            setIsMaps(true);
            setFormSocialLinks("maps", sLink?.link);
          }
          if (sLink?.name === "mail" && sLink?.link) {
            setIsMail(true);
            setFormSocialLinks("mail", sLink?.link);
          }
          if (sLink?.name === "telegram" && sLink?.link) {
            setIsTelegram(true);
            setFormSocialLinks("telegram", sLink?.link);
          }
          if (sLink?.name === "tiktok" && sLink?.link) {
            setIsTiktok(true);
            setFormSocialLinks("tiktok", sLink?.link);
          }
          if (sLink?.name === "snapchat" && sLink?.link) {
            setIsSnapchat(true);
            setFormSocialLinks("snapchat", sLink?.link);
          }
        });
        // qrSettings
        if (qrSetting) {
          setQrSettings(qrSetting);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        if (err?.response?.status === 400) {
          setIsBlocked(true);
        }
        console.error(err?.response?.data?.data);
        const error = err?.response?.data?.data || "Try Again";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
        setIsLoading(false);
      });
  };
  //eslint-disable-next-line
  useEffect(() => getQrCode(id), [id]);

  //   Funstions

  const handleDownloadQR = () => {
    const canvas = document.getElementById("react-qrcode-logo");
    const pngUrl = canvas
      ?.toDataURL("image/png")
      ?.replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = link + ".png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };

  //   States
  // 1. Colors
  const [colors, setColors] = useState({
    primary,
    secondary: primaryDark,
  });
  const [togglePicker, setTogglePicker] = useState(false);
  const [togglePicker1, setTogglePicker1] = useState(false);
  // profile image

  const [profileImageList, setProfileImageList] = useState([]);
  const [profileImage, setProfileImage] = useState();
  const postProfileImage = ({ file, onSuccess, onError }) => {
    setIsUploadingImage(true);
    const formData = new FormData();

    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("profileImage", compressedFile);
        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const newData = {
              uid: shortId(),
              name: data.profileImage,
              status: "done",
              url: Domain + "/data/" + data.profileImage,
            };

            setProfileImageList([...profileImageList, newData]);
            setProfileImage(newData);
            setIsUploadingImage(false);
          })
          .catch((err) => {
            console.error(err.response);

            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
            setIsUploadingImage(false);
          });
        return;
        // return uploadToServer(compressedFile); // write your own logic
      })
      .catch(function (error) {
        console.log(error.message); // output: I just want to stop
      });
    setIsUploadingImage(false);
  };

  // bg Image

  const [bgImageList, setBgImageList] = useState([]);
  const [bgImage, setBgImage] = useState();
  const postBgImage = ({ file, onSuccess, onError }) => {
    setIsUploadingImage(true);
    const formData = new FormData();
    // formData.append("bgImage", file);

    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("bgImage", compressedFile);
        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const newData = {
              uid: shortId(),
              name: data.bgImage,
              status: "done",
              url: Domain + "/data/" + data.bgImage,
            };

            setBgImageList([...bgImageList, newData]);
            setBgImage(newData);
            setIsUploadingImage(false);
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
            setIsUploadingImage(false);
          });
        return;
        // return uploadToServer(compressedFile); // write your own logic
      })
      .catch(function (error) {
        console.log(error.message); // output: I just want to stop
      });
    setIsUploadingImage(false);
  };
  //  upload image
  const postImage = ({ file, onSuccess, onError }) => {
    setIsUploadingImage(true);
    const formData = new FormData();
    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("images", compressedFile);

        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const newData = {
              uid: shortId(),
              name: data.images,
              status: "done",
              url: Domain + "/data/" + data.images,
            };
            setFileList([...fileList, newData]);
            setIsUploadingImage(false);
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
            setIsUploadingImage(false);
          });
        return;
        // return uploadToServer(compressedFile); // write your own logic
      })
      .catch(function (error) {
        console.log(error.message); // output: I just want to stop
      });
    setIsUploadingImage(false);
  };
  //Logo Image
  const [logoImageList, setLogoImageList] = useState([]);
  const postLogoImage = ({ file, onSuccess, onError }) => {
    setIsUploadingImage(true);
    const formData = new FormData();

    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("logoImage", compressedFile);
        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const newData = {
              uid: shortId(),
              name: data.logoImage,
              status: "done",
              url: Domain + "/data/" + data.logoImage,
            };

            setLogoImageList([...logoImageList, newData]);

            setQrSettings({ ...qrSettings, logoImage: newData?.name });
            setIsUploadingImage(false);
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
            setIsUploadingImage(false);
          });
        return;
      })
      .catch(function (error) {
        console.log(error.message); // output: I just want to stop
      });
    setIsUploadingImage(false);
  };
  //   image preview

  const [previewImage, setPreviewImage] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);

  // Basic Info
  const [basicInfo, setBasicInfo] = useState({
    fName: "",
    lName: "",
    fNamePrefix: "",
    lNameSuffix: "",
    mobile: "",
    mobile2: "",
    email: "",
    email2: "",
    phone: "",
    phone2: "",
    company: "",
    address: "",
    postalAddress: "",
    summary: "",
    jobTitle: "",
  });
  const [locationInfo, setLocationInfo] = useState({});
  const handleBasicInfo = (e) => {
    setBasicInfo({ ...basicInfo, [e.target.name]: e.target.value });
  };
  const contactExchangeOptions = [
    { label: "Phone", value: "exchangePhone" },
    { label: "Job Title", value: "exchangeJobTitle" },
    { label: "Website", value: "exchangeWebSite" },
    { label: "Comment", value: "exchangeComment" },
    { label: "Address", value: "exchangeAddress" },
  ];
  const optionsWithDisabled = [
    { label: "Phone", value: "exchangePhone", disabled: true },
    { label: "Job Title", value: "exchangeJobTitle", disabled: true },
    { label: "Website", value: "exchangeWebSite", disabled: true },
    { label: "Comment", value: "exchangeComment", disabled: true },
    { label: "Address", value: "exchangeAddress", disabled: true },
  ];
  const contactExchangeOptionArray = [
    "exchangePhone",
    "exchangeJobTitle",
    "exchangeWebSite",
    "exchangeComment",
    "exchangeAddress",
  ];
  const [contactExchangeEnabled, setContactExchangeEnabled] = useState(false);
  const [contactExchangeHeader, setContactExchangeHeader] = useState("");
  const [selectedContactExchangeOptions, setSelectedContactExchangeOption] =
    useState(contactExchangeOptionArray);
  const onCheckChange = (checkedValues) => {
    setSelectedContactExchangeOption(checkedValues);
  };
  //   Weblinks
  const [iconModal, setIconModal] = useState("");
  const [searchIconValue, setSearchIconValue] = useState("");
  const [searchedIcon, setSearchIcons] = useState([]);
  const [finalWebSites, setFinalWebSites] = useState([]);
  const [websites, setWebsites] = useState([]);
  const handleAddNewWebLink = () => {
    setWebsites([
      ...websites,
      { _id: shortId(), name: "", link: "", icon: "", image: "" },
    ]);
  };
  const handleremoveWebLink = (_id) => {
    const webLink = websites.find((link) => link._id === _id);

    const tempWebLinks = websites.filter((link) => link._id !== _id);
    if (webLink?.image) {
      handleRemoveCustomIcon(webLink.image, _id);
    }
    console.log({ tempWebLinks });
    setWebsites(tempWebLinks);
  };
  const handleUpdateWebLinksLink = () => {
    let check = true;
    const tempArray = [];
    websites.map((e) => {
      const item = JSON.parse(JSON.stringify(e));
      if (!item.name || !item.link) {
        check = false;
        setIsErrorModalVisible(true);
        return;
      } else {
        delete item._id;
        tempArray.push(item);
      }
    });
    if (check) {
      setFinalWebSites(tempArray);
    }
  };
  const onWebsiteValueChange = (e, _id) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          [e.target.name]:
            e.target.name === "link"
              ? e.target.value.replace("https://", "")
              : e.target.value,
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setWebsites(existingWebsites);
  };
  const handleAddIcon = (_id, icon) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          icon: icon,
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setIconModal("");
    setWebsites(existingWebsites);
  };
  const handleRemoveIcon = (_id) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          icon: "",
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setWebsites(existingWebsites);
  };
  const handleAddCustomIcon = ({ file, onSuccess, onError }, _id) => {
    const options = {
      signal: controller.signal,
      maxSizeMB: 0.05,
    };
    setIsUploadingImage(true);
    const formData = new FormData();
    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("customIcon", compressedFile);
        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const existingWebsites = [...websites];
            for (let index = 0; index < websites.length; index++) {
              if (_id === existingWebsites[index]?._id) {
                const toChangeWebsite = { ...existingWebsites[index] };
                const tempWebsite = {
                  ...toChangeWebsite,
                  image: data.customIcon,
                };
                existingWebsites[index] = tempWebsite;
              }
            }
            setIconModal("");
            setWebsites(existingWebsites);
            setIsUploadingImage(false);
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
            setIsUploadingImage(false);
          });
        return;
        // return uploadToServer(compressedFile); // write your own logic
      })
      .catch(function (error) {
        console.log(error.message); // output: I just want to stop
      });
    setIsUploadingImage(false);
  };
  const handleRemoveCustomIcon = (image, _id) => {
    setIsRemoving(true);
    request
      .put("qr/image", { image }, { headers: { ...authHeader() } })
      .then(() => {
        setIsRemoving(false);
      })
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
        setIsRemoving(false);
      });
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          image: "",
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setWebsites(existingWebsites);
  };
  const handleSearchIcon = () => {
    if (!searchIconValue) {
      setSearchIcons([]);
      return;
    }
    const searchedIcon = iconNames.filter((item) => {
      return item.match(searchIconValue.toLowerCase());
    });
    if (searchedIcon.length > 0) {
      setSearchIcons(searchedIcon);
    } else {
      setSearchIcons([]);
    }
  };
  const debounced = useDebouncedCallback(() => {
    handleSearchIcon();
  }, 500);
  useEffect(() => {
    if (!searchIconValue) {
      setSearchIcons([]);
      return;
    }
    debounced(searchIconValue);
  }, [debounced, searchIconValue]);
  ///
  const [youtubeLinks, setYoutubeLinks] = useState([]);
  // images upload
  const [fileList, setFileList] = useState([
    // {
    //   uid: "-1",
    //   name: "image.png",
    //   status: "done",
    //   url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    // },
  ]);
  // social Links
  //eslint-disable-next-line
  const [socialLinks, setSocialLinks] = useState([]);
  const [isFacebook, setIsFacebook] = useState(false);
  const [isInstagram, setIsInstagram] = useState(false);
  const [isLinkedin, setIsLinkedin] = useState(false);
  const [isTwitter, setIsTwitter] = useState(false);
  const [isSkype, setIsSkype] = useState(false);
  const [isBehance, setIsBehance] = useState(false);
  const [isYoutube, setIsYoutube] = useState(false);
  const [isWhatsapp, setIsWhatsapp] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isMail, setIsMail] = useState(false);
  const [isTelegram, setIsTelegram] = useState(false);
  const [isTiktok, setIsTiktok] = useState(false);
  const [isSnapchat, setIsSnapchat] = useState(false);
  //  QR Settings
  const [showQr, setShowQr] = useState(false);
  const [showContactExchange, setShowContactExchange] = useState(false);

  const [pPicker, setPPicker] = useState(false);
  const [sPicker, setSPicker] = useState(false);
  const [qrSettings, setQrSettings] = useState({
    size: 256,
    quietZone: 10,
    ecLevel: "L",
    bgColor: "#FFFFFF",
    fgColor: "#000000",
    logoImage: "",
    logoWidth: 50,
    logoHeight: 50,
    logoOpacity: 1,
    qrStyle: "squares",
    eyeRadius: 0,
  });

  // Edit Qr
  const [isEditting, setIsEditing] = useState(false);
  const EditQr = (d) => {
    setIsEditing(true);
    request
      .put(API + "/qr/" + qrData?._id, d, {
        headers: { ...authHeader() },
      })
      .then((data) => {
        setIsEditing(false);
        message.success("QR Updated");
        // history.push("/app/my-wave-code");
      })
      .catch((err) => {
        // console.error(err?.response?.data?.data);
        openNotification({
          message: "Error",
          description: err?.response?.data?.data,
          icon: "error",
        });
        setIsEditing(false);
      });
  };
  // image remove

  const [isRemoving, setIsRemoving] = useState(false);
  const handleImageRemove = (image, key) => {
    setIsRemoving(true);
    request
      .put(
        `qr/image/${qrData?._id}`,
        { [key]: image },
        { headers: { ...authHeader() } }
      )
      .then(() => {
        setIsRemoving(false);
      })
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
        setIsRemoving(false);
      });
  };
  return (
    <Layout
      heading={role === WHITE_LABEL_ADMIN ? "Edit Card" : "Edit Wave Card"}
    >
      <Helmet>
        {role === WHITE_LABEL_ADMIN ? (
          <title>Dynamic Cards | Edit</title>
        ) : (
          <title>Dynamic Wave Cards | Edit</title>
        )}
      </Helmet>
      {isLoading ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            className="spin-loader"
            src={loader}
            preview={false}
            draggable={false}
          />
        </div>
      ) : isBlocked ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <h1
            style={{
              marginTop: 24,
              fontWeight: "300",
              display: "flex",
              alignItems: "center",
            }}
          >
            <BiCommentError style={{ marginRight: 15 }} />
            Aw Snap!
          </h1>
          <h1 style={{ marginTop: 24, fontWeight: "700" }}>
            Wave Code is Blocked
          </h1>
          <p style={{ marginTop: 24, color: "lightgray" }}>
            Please Contact Support
          </p>
        </div>
      ) : (
        <Row className="mainContainer">
          <Modal
            visible={isUploadingImage}
            footer={null}
            closable={false}
            centered
            bodyStyle={{
              margin: "0 auto",
              width: 350,
              height: 350,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Image
              className="spin-loader"
              src={loader}
              preview={false}
              draggable={false}
            />
          </Modal>
          <Modal
            visible={isRemoving}
            footer={null}
            closable={false}
            centered
            bodyStyle={{
              margin: "0 auto",
              width: 350,
              height: 350,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Image
              className="spin-loader"
              src={loader}
              preview={false}
              draggable={false}
            />
          </Modal>
          <Col span={16} className="subContainer">
            <Row style={{ maxWidth: "unset" }}>
              <Col md={20}>
                <Form
                  initialValues={{ websites, youtubeLinks }}
                  form={form}
                  name="edit-wave-code-form"
                  className="create-qr-form"
                  onFinish={(e) => {
                    const { primary, secondary } = colors;
                    const {
                      fName,
                      lName,
                      fNamePrefix,
                      lNameSuffix,
                      email,
                      email2,
                      address,
                      postalAddress,
                      jobTitle,
                      company,
                      mobile,
                      mobile2,
                      summary,
                      phone,
                      phone2,
                    } = basicInfo;
                    setIsErrorModalVisible(!basicInfo?.fName);
                    const data = {
                      pColor: primary,
                      sColor: secondary,
                      fName,
                      lName,
                      fNamePrefix,
                      lNameSuffix,
                      email,
                      email2,
                      address,
                      postalAddress,
                      company,
                      mobile,
                      mobile2,
                      jobTitle,
                      summary,
                      link,
                      phone,
                      phone2,
                      showQr,
                      sectionOrder,
                      contactExchangeHeader,
                      selectedContactExchangeOptions,
                      webLinks: finalWebSites,
                      youtubeLinks: e.youtubelinks,
                      leadEnable: contactExchangeEnabled,
                      locationInfo,
                      selectedTheme,
                      images: fileList.map((img) => img?.name),
                      profileImage:
                        (profileImage?.name ? profileImage?.name : null) ||
                        (profileImage ? profileImage : null),
                      bgImage:
                        (bgImage?.name ? bgImage?.name : null) ||
                        (bgImage ? bgImage : null),
                      socialLinks: [
                        {
                          name: "facebook",
                          link: form?.getFieldValue("facebook")
                            ? form
                                ?.getFieldValue("facebook")
                                ?.includes("facebook.com")
                              ? form?.getFieldValue("facebook")
                              : "facebook.com/" +
                                form?.getFieldValue("facebook")
                            : "",
                        },
                        {
                          name: "instagram",
                          link: form?.getFieldValue("instagram")
                            ? form
                                ?.getFieldValue("instagram")
                                ?.includes("instagram.com")
                              ? form?.getFieldValue("instagram")
                              : "instagram.com/" +
                                form?.getFieldValue("instagram")
                            : "",
                        },
                        {
                          name: "linkedin",
                          link: form?.getFieldValue("linkedin")
                            ? form
                                ?.getFieldValue("linkedin")
                                ?.includes("linkedin.com/in/")
                              ? form.getFieldValue("linkedin")
                              : "linkedin.com/in/" +
                                form.getFieldValue("linkedin")
                            : "",
                        },
                        {
                          name: "twitter",
                          link: form?.getFieldValue("twitter")
                            ? form
                                ?.getFieldValue("twitter")
                                ?.includes("twitter.com")
                              ? form?.getFieldValue("twitter")
                              : "twitter.com/" + form?.getFieldValue("twitter")
                            : "",
                        },
                        {
                          name: "skype",
                          link: form?.getFieldValue("skype")
                            ? form
                                ?.getFieldValue("skype")
                                ?.includes("skype.com")
                              ? form?.getFieldValue("skype")
                              : "skype.com/" + form?.getFieldValue("skype")
                            : "",
                        },
                        {
                          name: "behance",
                          link: form?.getFieldValue("behance")
                            ? form
                                ?.getFieldValue("behance")
                                ?.includes("behance.com")
                              ? form?.getFieldValue("behance")
                              : "behance.com/" + form?.getFieldValue("behance")
                            : "",
                        },
                        {
                          name: "youtube",
                          link: form?.getFieldValue("youtube")
                            ? form
                                ?.getFieldValue("youtube")
                                ?.includes("youtube.com")
                              ? form?.getFieldValue("youtube")
                              : "youtube.com/" + form?.getFieldValue("youtube")
                            : "",
                        },
                        {
                          name: "whatsapp",
                          link: form?.getFieldValue("whatsapp")
                            ? form?.getFieldValue("whatsapp")?.includes("wa.me")
                              ? form?.getFieldValue("whatsapp")
                              : "wa.me/" + form?.getFieldValue("whatsapp")
                            : "",
                        },
                        {
                          name: "maps",
                          link: form?.getFieldValue("maps")
                            ? form
                                ?.getFieldValue("maps")
                                ?.includes("goo.gl/maps")
                              ? form?.getFieldValue("maps")
                              : "goo.gl/maps/" + form?.getFieldValue("maps")
                            : "",
                        },
                        { name: "mail", link: form?.getFieldValue("mail") },
                        {
                          name: "telegram",
                          link: form?.getFieldValue("telegram")
                            ? form?.getFieldValue("telegram")?.includes("t.me")
                              ? form?.getFieldValue("telegram")
                              : "t.me/" + form?.getFieldValue("telegram")
                            : "",
                        },
                        {
                          name: "tiktok",
                          link: form?.getFieldValue("tiktok")
                            ? form
                                ?.getFieldValue("tiktok")
                                ?.includes("vt.tiktok.com")
                              ? form?.getFieldValue("tiktok")
                              : "vt.tiktok.com/" + form?.getFieldValue("tiktok")
                            : "",
                        },
                        {
                          name: "snapchat",
                          link: form?.getFieldValue("snapchat")
                            ? form
                                ?.getFieldValue("snapchat")
                                ?.includes("snapchat.com/add")
                              ? form?.getFieldValue("snapchat")
                              : "snapchat.com/add/" +
                                form?.getFieldValue("snapchat")
                            : "",
                        },
                      ],
                      qrSetting: qrSettings,
                    };
                    if ((!fName && !email) || fName === "Your") {
                    } else {
                      EditQr(data);
                    }
                  }}
                  onFinishFailed={(e) => console.error(e)}
                >
                  <Collapse
                    defaultActiveKey={["1"]}
                    bordered={false}
                    className="site-collapse-custom-panel"
                    expandIcon={({ isActive }) => (
                      <DoubleRightOutlined rotate={isActive ? 90 : 0} />
                    )}
                  >
                    <Panel header="Design and Customize" key={1}>
                      <span
                        onClick={() => {
                          setTogglePicker(false);
                          setTogglePicker1(false);
                        }}
                      >
                        <h3> Background Colors</h3>
                        <Item name="color">
                          <Row
                            gutter={10}
                            style={{ marginTop: 24, width: "25rem" }}
                          >
                            <Col span={4}>
                              <h4>Presets</h4>
                            </Col>
                            <Col span={20}>
                              <Space className="color-selection-containter">
                                <div className="color-selection-subContainter">
                                  <div
                                    className="color-selection-box"
                                    onClick={() => {
                                      setColors({
                                        primary: primary,
                                        secondary: primaryDark,
                                      });
                                    }}
                                  >
                                    <div
                                      className="top"
                                      style={{ background: primary }}
                                    />
                                    <div
                                      className="bottom"
                                      style={{ background: primaryDark }}
                                    />
                                  </div>
                                  <div
                                    className="color-selection-box"
                                    onClick={() => {
                                      setColors({
                                        primary: "#E7A14A",
                                        secondary: "#10171E",
                                      });
                                    }}
                                  >
                                    <div
                                      className="top"
                                      style={{ background: "#E7A14A" }}
                                    />
                                    <div
                                      className="bottom"
                                      style={{ background: "#10171E" }}
                                    />
                                  </div>
                                </div>
                                <div className="color-selection-subContainter">
                                  <div
                                    className="color-selection-box"
                                    onClick={() => {
                                      setColors({
                                        primary: "#333333",
                                        secondary: "#ED6363",
                                      });
                                    }}
                                  >
                                    <div
                                      className="top"
                                      style={{ background: "#333333" }}
                                    />
                                    <div
                                      className="bottom"
                                      style={{ background: "#ED6363" }}
                                    />
                                  </div>
                                  <div
                                    className="color-selection-box"
                                    onClick={() => {
                                      setColors({
                                        primary: "#CEB996",
                                        secondary: "#322F44",
                                      });
                                    }}
                                  >
                                    <div
                                      className="top"
                                      style={{ background: "#CEB996" }}
                                    />
                                    <div
                                      className="bottom"
                                      style={{ background: "#322F44" }}
                                    />
                                  </div>
                                </div>
                              </Space>
                            </Col>
                          </Row>

                          {/* color picker */}
                          <Row
                            gutter={10}
                            style={{
                              marginTop: 24,
                              width: "25rem",
                              alignItems: "center",
                            }}
                          >
                            <Col span={4}>
                              <h4>Select Colors</h4>
                            </Col>
                            <Col className="colorPickerContainer" span={20}>
                              <Col
                                span={10}
                                style={{
                                  marginBottom: ".5rem",
                                }}
                              >
                                <Input
                                  onChange={(e) =>
                                    setColors({
                                      ...colors,
                                      primary: e.target.value,
                                    })
                                  }
                                  size="large"
                                  prefix={
                                    <>
                                      <CgColorPicker
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setTogglePicker(!togglePicker);
                                        }}
                                        style={{
                                          background: colors.primary,
                                          color: "white",
                                          width: 30,
                                          padding: 5,
                                          height: "100%",
                                          borderRadius: 8,
                                        }}
                                      />

                                      {togglePicker && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 60,
                                            zIndex: 9999,
                                          }}
                                        >
                                          <SketchPicker
                                            color={colors.primary}
                                            onChange={(e) =>
                                              setColors({
                                                ...colors,
                                                primary: `rgba(${e.rgb.r},${e.rgb.g},${e.rgb.b},${e.rgb.a})`,
                                              })
                                            }
                                          />
                                        </div>
                                      )}
                                    </>
                                  }
                                  style={{ borderRadius: 8 }}
                                  value={colors.primary}
                                />
                              </Col>
                              <Col
                                span={10}
                                style={{
                                  marginBottom: ".5rem",
                                }}
                              >
                                <Input
                                  onChange={(e) =>
                                    setColors({
                                      ...colors,
                                      secondary: e.target.value,
                                    })
                                  }
                                  size="large"
                                  prefix={
                                    <>
                                      <CgColorPicker
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setTogglePicker1(!togglePicker1);
                                        }}
                                        style={{
                                          background: colors.secondary,
                                          color: "white",
                                          width: 30,
                                          padding: 5,
                                          height: "100%",
                                          borderRadius: 8,
                                        }}
                                      />

                                      {togglePicker1 && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 60,
                                            zIndex: 9999,
                                          }}
                                        >
                                          <SketchPicker
                                            color={colors.secondary}
                                            onChange={(e) => {
                                              setColors({
                                                ...colors,
                                                secondary: `rgba(${e.rgb.r},${e.rgb.g},${e.rgb.b},${e.rgb.a})`,
                                              });
                                            }}
                                          />
                                        </div>
                                      )}
                                    </>
                                  }
                                  style={{ borderRadius: 8 }}
                                  value={colors.secondary}
                                />
                              </Col>
                            </Col>
                          </Row>
                          <br />

                          <Row gutter={10} style={{ marginTop: 24 }}>
                            <Col>
                              <h4>Profile Image</h4>
                              <p className="subText">Size: 500 KB</p>
                              <p className="subText">
                                Dimension: 120 x 120 px{" "}
                              </p>
                              <p className="subText">
                                Max Dimensions: 1024 x 1024 px{" "}
                              </p>
                            </Col>
                            <Col>
                              <ImgCrop
                                rotate
                                modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
                                quality={1}
                                shape="round"
                                fillColor="#00000000"
                              >
                                <Upload
                                  className="fileList-upload-images"
                                  maxCount={1}
                                  customRequest={postProfileImage}
                                  listType="picture-card"
                                  fileList={profileImageList}
                                  onRemove={(e) =>
                                    handleImageRemove(e?.name, "profileImage")
                                  }
                                  onPreview={handlePreview}
                                  onChange={(e) => {
                                    setProfileImageList(
                                      profileImageList.filter(
                                        (f) => f.uid !== e?.file?.uid
                                      )
                                    );
                                    setProfileImage();
                                  }}
                                  // beforeUpload={(file) => {
                                  //   // const isLt2M = file.size / 1024 / 1024 < 2;
                                  //   const isLt2M = file.size / 1024 <= 500; //less than 500 KB

                                  //   if (!isLt2M) {
                                  //     file.flag = true;
                                  //     message.error(
                                  //       "Please upload image less than 500Kb"
                                  //     );
                                  //     return false;
                                  //   }
                                  //   return true;
                                  // }}
                                  accept="image/*"
                                >
                                  {profileImageList.length === 1 ? null : (
                                    <PlusOutlined />
                                  )}
                                </Upload>
                              </ImgCrop>
                            </Col>
                          </Row>
                          <Row gutter={10} style={{ marginTop: 24 }}>
                            <Col>
                              <h4>Background Image</h4>
                              <p className="subText">Size: 500 KB</p>
                              <p className="subText">
                                Dimension: 550 x 300 px{" "}
                              </p>
                              <p className="subText">
                                Max Dimensions: 1024 x 1024 px{" "}
                              </p>
                            </Col>
                            <Col>
                              <ImgCrop
                                rotate
                                quality={1}
                                modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
                                minZoom={1}
                                maxZoom={10}
                                aspect={2 / 1}
                                modalWidth={530}
                                fillColor="#00000000"
                              >
                                <Upload
                                  className="fileList-upload-images"
                                  maxCount={1}
                                  customRequest={postBgImage}
                                  listType="picture-card"
                                  fileList={bgImageList}
                                  onPreview={handlePreview}
                                  onRemove={(e) =>
                                    handleImageRemove(e?.name, "bgImage")
                                  }
                                  onChange={(e) => {
                                    setBgImageList(
                                      bgImageList.filter(
                                        (f) => f.uid !== e?.file?.uid
                                      )
                                    );
                                    setBgImage();
                                  }}
                                  // beforeUpload={(file) => {
                                  //   // const isLt2M = file.size / 1024 / 1024 < 2;
                                  //   const isLt2M = file.size / 1024 <= 500; //less than 500 KB

                                  //   if (!isLt2M) {
                                  //     file.flag = true;
                                  //     message.error(
                                  //       "Please upload image less than 500Kb"
                                  //     );
                                  //     return false;
                                  //   }
                                  //   return true;
                                  // }}
                                  accept="image/*"
                                >
                                  {bgImageList.length === 1 ? null : (
                                    <PlusOutlined />
                                  )}
                                </Upload>
                              </ImgCrop>
                            </Col>
                          </Row>
                          <Row gutter={10} style={{ marginTop: 24 }}>
                            <Col>
                              <h4>Select Profile</h4>
                              <p className="subText">Change between profiles</p>
                              <p className="subText" style={{ color: "red" }}>
                                Premium feature
                              </p>
                            </Col>
                            <ProfileButtons
                              profiles={profiles}
                              setProfileManagementModal={
                                setProfileManagementModal
                              }
                              selectedProfileId={selectedProfileId}
                            />
                          </Row>
                          <Row gutter={10} style={{ marginTop: 24 }}>
                            <Col>
                              <h4>Select Theme</h4>
                              <p className="subText">Change between theme</p>
                              <p className="subText" style={{ color: "red" }}>
                                Premium feature
                              </p>
                            </Col>
                            <ThemeSlider
                              selectedTheme={selectedTheme}
                              setSelectedTheme={setSelectedTheme}
                            />
                          </Row>
                        </Item>
                      </span>
                    </Panel>
                    <Panel header="Basic Information" key={2}>
                      <Row span={24}>
                        <Col xs={8} md={4}>
                          <h4>Name</h4>
                        </Col>
                        <Col xs={24} md={10}>
                          <Row gutter={24}>
                            <Col xs={10} md={10}>
                              <Item
                                name="fNamePrefix"
                                initialValue={basicInfo.fNamePrefix}
                              >
                                <Input
                                  size="large"
                                  name="fNamePrefix"
                                  value={basicInfo.fNamePrefix}
                                  onChange={handleBasicInfo}
                                  style={{ borderRadius: 8 }}
                                  placeholder="Prefix"
                                />
                              </Item>
                            </Col>
                            <Col xs={14} md={13}>
                              <Item
                                name="fName"
                                initialValue={basicInfo.fName}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                              >
                                <Input
                                  size="large"
                                  name="fName"
                                  value={basicInfo.fName}
                                  onChange={handleBasicInfo}
                                  style={{ borderRadius: 8 }}
                                  placeholder="fFirst Name"
                                />
                              </Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24} md={10}>
                          <Row gutter={24} justify="space-between">
                            <Col xs={14} md={13}>
                              <Item name="lName" initialValue={basicInfo.lName}>
                                <Input
                                  size="large"
                                  name="lName"
                                  value={basicInfo.lName}
                                  onChange={handleBasicInfo}
                                  style={{ borderRadius: 8 }}
                                  placeholder="Last Name"
                                />
                              </Item>
                            </Col>
                            <Col xs={10} md={10}>
                              <Item
                                name="lNameSuffix"
                                initialValue={basicInfo.lNameSuffix}
                              >
                                <Input
                                  size="large"
                                  name="lNameSuffix"
                                  value={basicInfo.lNameSuffix}
                                  onChange={handleBasicInfo}
                                  style={{ borderRadius: 8 }}
                                  placeholder="Suffix"
                                />
                              </Item>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col xs={24} md={12}>
                          <Row xs={24} md={12}>
                            <Col xs={8} md={8}>
                              <h4>Mobile Number</h4>
                            </Col>
                            <Col xs={16} md={15}>
                              <Item
                                name="mobile"
                                initialValue={basicInfo.mobile}
                              >
                                <Input
                                  size="large"
                                  name="mobile"
                                  value={basicInfo.mobile}
                                  onChange={handleBasicInfo}
                                  style={{ borderRadius: 8 }}
                                  placeholder="Number"
                                />
                              </Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24} md={12}>
                          <Row justify="space-between">
                            <Col xs={8} md={8}>
                              <h4>Mobile Number 2</h4>
                            </Col>
                            <Col xs={16} md={15}>
                              <Item
                                name="mobile2"
                                initialValue={basicInfo.mobile2}
                              >
                                <Input
                                  size="large"
                                  name="mobile2"
                                  value={basicInfo.mobile2}
                                  onChange={handleBasicInfo}
                                  style={{ borderRadius: 8 }}
                                  placeholder="Number"
                                />
                              </Item>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col xs={24} md={12}>
                          <Row xs={24} md={12}>
                            <Col xs={8} md={8}>
                              <h4>Phone Number</h4>
                            </Col>
                            <Col xs={16} md={15}>
                              <Item name="phone" initialValue={basicInfo.phone}>
                                <Input
                                  size="large"
                                  name="phone"
                                  value={basicInfo.phone}
                                  onChange={handleBasicInfo}
                                  style={{ borderRadius: 8 }}
                                  placeholder="Number"
                                />
                              </Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24} md={12}>
                          <Row justify="space-between">
                            <Col xs={8} md={8}>
                              <h4>Phone Number 2</h4>
                            </Col>
                            <Col xs={16} md={15}>
                              <Item
                                name="phone2"
                                initialValue={basicInfo.phone2}
                              >
                                <Input
                                  size="large"
                                  name="phone2"
                                  value={basicInfo.phone2}
                                  onChange={handleBasicInfo}
                                  style={{ borderRadius: 8 }}
                                  placeholder="Number"
                                />
                              </Item>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col xs={24} md={12}>
                          <Row xs={24} md={12}>
                            <Col xs={8} md={8}>
                              <h4>Email</h4>
                            </Col>
                            <Col xs={16} md={15}>
                              <Item
                                initialValue={basicInfo?.email}
                                name="email"
                                rules={[
                                  {
                                    type: "email",
                                    message: "Please Enter correct Email!",
                                  },
                                ]}
                              >
                                <Input
                                  size="large"
                                  name="email"
                                  value={basicInfo.email}
                                  onChange={handleBasicInfo}
                                  style={{ borderRadius: 8 }}
                                  placeholder="Your Email Id"
                                />
                              </Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24} md={12}>
                          <Row justify="space-between">
                            <Col xs={8} md={8}>
                              <h4>Email 2</h4>
                            </Col>
                            <Col xs={16} md={15}>
                              <Item
                                initialValue={basicInfo?.email2}
                                name="email2"
                                rules={[
                                  {
                                    type: "email",
                                    message: "Please Enter correct Email!",
                                  },
                                ]}
                              >
                                <Input
                                  size="large"
                                  name="email2"
                                  value={basicInfo.email2}
                                  onChange={handleBasicInfo}
                                  style={{ borderRadius: 8 }}
                                  placeholder="Your Email Id "
                                />
                              </Item>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col xs={8} md={4}>
                          <h4>Job Title</h4>
                        </Col>
                        <Col xs={24} md={20}>
                          <Item
                            name="jobTitle"
                            initialValue={basicInfo.jobTitle}
                          >
                            <Input
                              size="large"
                              name="jobTitle"
                              value={basicInfo.jobTitle}
                              onChange={handleBasicInfo}
                              style={{ borderRadius: 8 }}
                              placeholder="Your Job Title"
                            />
                          </Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col xs={8} md={4}>
                          <h4>Company</h4>
                        </Col>
                        <Col xs={24} md={20}>
                          <Item name="company" initialValue={basicInfo.company}>
                            <Input
                              size="large"
                              name="company"
                              value={basicInfo.company}
                              onChange={handleBasicInfo}
                              style={{ borderRadius: 8 }}
                              placeholder="Your Company Name"
                            />
                          </Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col xs={8} md={4}>
                          <h4>Address</h4>
                        </Col>
                        <Col xs={24} md={20}>
                          <Item name="address" initialValue={basicInfo.address}>
                            <LocationSearch
                              placeholder="Your Address"
                              value={basicInfo.address}
                              onChange={handleBasicInfo}
                              name="address"
                              setLocationInfo={setLocationInfo}
                            />
                          </Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col xs={8} md={4}>
                          <h4>Postal Address</h4>
                        </Col>
                        <Col xs={24} md={20}>
                          <Item
                            name="postalAddress"
                            initialValue={basicInfo.postalAddress}
                          >
                            <Input.TextArea
                              size="large"
                              name="postalAddress"
                              value={basicInfo.postalAddress}
                              onChange={handleBasicInfo}
                              autoSize={{ minRows: 3 }}
                              maxLength={150}
                              style={{ borderRadius: 8 }}
                              placeholder="Your Postal Address"
                            />
                          </Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col xs={8} md={4}>
                          <h4>Summary</h4>
                        </Col>
                        <Col xs={24} md={20}>
                          <Item
                            name="summary"
                            initialValue={basicInfo?.summary || ""}
                          >
                            <ReactQuill
                              name="summary"
                              value={basicInfo.summary || ""}
                              onChange={(e) => {
                                const target = {
                                  name: "summary",
                                  value: e,
                                };
                                const temp = { target };
                                handleBasicInfo(temp);
                              }}
                              placeholder="A brief description about yourself"
                              style={{ borderRadius: 8 }}
                            />
                          </Item>
                        </Col>
                      </Row>
                    </Panel>
                    {(role === SUPER_ADMIN ||
                      role === SUPER_ADMIN_EDITOR ||
                      role === DEVELOPER) &&
                    _id !== qrData.owner ? null : (
                      <Panel header="Contact Exchange" key={3}>
                        <Col span={24}>
                          <Row span={24}>
                            <Col xs={12} md={8}>
                              <h4>Contact Exchange Enable</h4>
                              <p style={{ fontSize: 12, color: "red" }}>
                                premium feature
                              </p>
                            </Col>
                            <Col xs={12} md={16}>
                              <Switch
                                style={{
                                  background: contactExchangeEnabled
                                    ? "#55B659"
                                    : "#FF6461",
                                }}
                                disabled={
                                  role === SUPER_ADMIN ||
                                  role === SUPER_ADMIN_EDITOR ||
                                  role === DEVELOPER
                                    ? false
                                    : subscribedPlan?.paymentStatus !==
                                      "SUCCESS"
                                }
                                checkedChildren={"ENABLE"}
                                unCheckedChildren={"DISABLE"}
                                checked={contactExchangeEnabled}
                                onChange={() => {
                                  request
                                    .post(
                                      `leadgeneration/enableLeadGeneration`,
                                      {
                                        qrId: qrData._id,
                                      }
                                    )
                                    .then(({ data }) => {
                                      const { leadEnable } = data?.data;
                                      setContactExchangeEnabled(
                                        leadEnable || false
                                      );
                                    })
                                    .catch((err) => {
                                      console.log("error=>", err);
                                      setContactExchangeEnabled(false);
                                      const error =
                                        err?.response?.data.data ||
                                        err?.response?.statusText;
                                      openNotification({
                                        message: "Error",
                                        description: error,
                                        icon: "error",
                                      });
                                    });
                                }}
                              />
                            </Col>
                          </Row>
                          <Row span={24}>
                            <Col xs={8} md={4}>
                              <h4>Header Title</h4>
                            </Col>
                            <Col xs={16} md={20}>
                              <Item
                                name="exchangeHeader"
                                initialValue={contactExchangeHeader}
                              >
                                <Input
                                  size="large"
                                  name="exchangeHeader"
                                  value={contactExchangeHeader}
                                  onChange={(e) =>
                                    setContactExchangeHeader(e.target.value)
                                  }
                                  disabled={!contactExchangeEnabled}
                                  style={{ borderRadius: 8 }}
                                  placeholder="Contact Exchange Header"
                                />
                              </Item>
                            </Col>
                          </Row>
                          <Row span={24}>
                            <Col xs={8} md={4}>
                              <h4>Fields</h4>
                            </Col>
                            <Col xs={16} md={20}>
                              <Checkbox.Group
                                options={
                                  contactExchangeEnabled
                                    ? contactExchangeOptions
                                    : optionsWithDisabled
                                }
                                defaultValue={selectedContactExchangeOptions}
                                onChange={onCheckChange}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Panel>
                    )}
                    <Panel header="Web Links" key={4}>
                      <Row span={24} align="space-between">
                        <Col xs={24} md={4}>
                          <h4>Weblinks</h4>
                          <p className="subText">
                            Please Input your website link in the first field.
                          </p>
                          <p
                            style={{
                              color: danger,
                              fontSize: 11,
                              fontWeight: "500",
                            }}
                          >
                            * First Link will be saved in your vcf file{" "}
                          </p>
                        </Col>
                        <Col xs={24} md={19}>
                          <div style={{ marginBottom: "1rem" }}>
                            {websites.map((website, index) => {
                              return (
                                <Space
                                  key={index}
                                  wrap={true}
                                  style={{ marginBottom: "1rem" }}
                                >
                                  {website?.icon ? (
                                    <i
                                      onClick={() => {
                                        handleRemoveIcon(website._id);
                                      }}
                                      className={`fas fa-${website?.icon} fa-2x`}
                                      style={{
                                        margin: "1rem",
                                        cursor: "pointer",
                                      }}
                                    />
                                  ) : website?.image ? (
                                    <img
                                      onClick={() => {
                                        handleRemoveCustomIcon(
                                          website.image,
                                          website._id
                                        );
                                      }}
                                      src={Domain + "/data/" + website.image}
                                      style={{
                                        width: "2rem",
                                        height: "2rem",
                                        cursor: "pointer",
                                        margin: "1rem",
                                      }}
                                      alt="icon"
                                    />
                                  ) : (
                                    <Button
                                      size="large"
                                      onClick={() => setIconModal(website._id)}
                                      style={{ borderRadius: 8 }}
                                    >
                                      Icon
                                    </Button>
                                  )}

                                  <Input
                                    name="name"
                                    style={{ borderRadius: 8 }}
                                    placeholder="Link"
                                    size="large"
                                    value={website.name}
                                    onChange={(e) =>
                                      onWebsiteValueChange(e, website._id)
                                    }
                                  />

                                  <Input
                                    name="link"
                                    style={{ borderRadius: 8 }}
                                    size="large"
                                    value={website.link}
                                    placeholder="www.mywebsiteurl.com"
                                    prefix={
                                      <>
                                        <LinkOutlined
                                          style={{ paddingRight: 5 }}
                                        />{" "}
                                        https://
                                      </>
                                    }
                                    onChange={(e) =>
                                      onWebsiteValueChange(e, website._id)
                                    }
                                  />

                                  <Button
                                    size="large"
                                    danger
                                    onClick={() => {
                                      handleremoveWebLink(website._id);
                                    }}
                                    style={{ borderRadius: 8 }}
                                    icon={
                                      <DeleteOutlined
                                        className="linkDeleteIcon"
                                        style={{ fontSize: 18 }}
                                      />
                                    }
                                  >
                                    Remove
                                  </Button>
                                </Space>
                              );
                            })}
                          </div>
                          <Button
                            type="dashed"
                            onClick={() => {
                              handleAddNewWebLink();
                            }}
                            block
                            icon={<PlusOutlined />}
                            style={{ borderRadius: 8, marginBottom: "2rem" }}
                          >
                            Add Links
                          </Button>
                          <Button
                            size="large"
                            onClick={() => {
                              handleUpdateWebLinksLink();
                            }}
                            style={{ borderRadius: 8 }}
                          >
                            Update
                          </Button>
                        </Col>
                      </Row>
                    </Panel>
                    <Panel header="Images Upload" key={5}>
                      <Row span={24}>
                        <Col xs={24} md={4}>
                          <h4>Images</h4>
                          <p className="subText">Max 3/{fileList.length}</p>
                          <p className="subText">Size: 500 KB</p>
                        </Col>
                        <Col xs={24} md={20}>
                          <ImgCrop
                            rotate
                            modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
                            quality={1}
                            aspect={9 / 6}
                            modalWidth={720}
                            shape="rect"
                            fillColor="#00000000"
                          >
                            <Upload
                              className="fileList-upload-images"
                              maxCount={3}
                              customRequest={postImage}
                              listType="picture-card"
                              fileList={fileList}
                              onPreview={handlePreview}
                              onRemove={(e) =>
                                handleImageRemove(e?.name, "images")
                              }
                              onChange={(e) => {
                                setFileList(
                                  fileList.filter((f) => f.uid !== e?.file?.uid)
                                );
                              }}
                              // beforeUpload={(file) => {
                              //   // const isLt2M = file.size / 1024 / 1024 < 2;
                              //   const isLt2M = file.size / 1024 <= 500; //less than 500 KB

                              //   if (!isLt2M) {
                              //     file.flag = true;
                              //     message.error(
                              //       "Please upload image less than 500Kb"
                              //     );
                              //     return false;
                              //   }
                              //   return true;
                              // }}
                              accept="image/*"
                            >
                              {fileList.length >= 3 ? null : <PlusOutlined />}
                            </Upload>
                          </ImgCrop>
                        </Col>
                      </Row>
                    </Panel>
                    {subscribedPlan?.paymentStatus === "SUCCESS" ||
                    role === SUPER_ADMIN ||
                    role === SUPER_ADMIN_EDITOR ||
                    role === DEVELOPER ? (
                      <Panel header="Youtube Videos" key={6}>
                        <Row span={10}>
                          <Col xs={24} md={4}>
                            <h4>Youtube</h4>
                            <p className="subText">
                              Please Input youtube video link in the first
                              field.
                            </p>
                          </Col>
                          <Col xs={24} md={19}>
                            <Form.List name="youtubelinks">
                              {(fields, { add, remove, move }) => {
                                return (
                                  <>
                                    {fields.map(
                                      ({ key, name, ...restField }) => {
                                        return (
                                          <Space
                                            key={key}
                                            className="webLinkMain"
                                            align="baseline"
                                          >
                                            <Form.Item
                                              {...restField}
                                              initialValue=""
                                              name={[name, "link"]}
                                              rules={[
                                                {
                                                  required: true,
                                                  message: "Missing Url",
                                                },
                                              ]}
                                            >
                                              <Input
                                                style={{ borderRadius: 8 }}
                                                size="large"
                                                placeholder="www.youtube.com/url"
                                                prefix={
                                                  <>
                                                    <LinkOutlined
                                                      style={{
                                                        paddingRight: 5,
                                                      }}
                                                    />
                                                  </>
                                                }
                                              />
                                            </Form.Item>

                                            <Button
                                              size="large"
                                              danger
                                              onClick={() => remove(name)}
                                              style={{ borderRadius: 8 }}
                                              icon={
                                                <DeleteOutlined
                                                  className="linkDeleteIcon"
                                                  style={{ fontSize: 18 }}
                                                />
                                              }
                                            >
                                              Remove
                                            </Button>
                                          </Space>
                                        );
                                      }
                                    )}
                                    <Form.Item>
                                      <Button
                                        disabled={
                                          form?.getFieldValue("youtubelinks")
                                            ?.length > 2
                                            ? true
                                            : false
                                        }
                                        type="dashed"
                                        onClick={() => add()}
                                        block
                                        icon={<PlusOutlined />}
                                        style={{ borderRadius: 8 }}
                                      >
                                        Add Links
                                      </Button>
                                    </Form.Item>
                                    <Button
                                      size="large"
                                      onClick={() => {
                                        form?.getFieldValue("youtubelinks")
                                          ?.length === 0 &&
                                          setYoutubeLinks(
                                            form?.getFieldValue("youtubelinks")
                                          );

                                        form
                                          ?.getFieldValue("youtubelinks")
                                          ?.map((v) => {
                                            if (!v?.link) {
                                              setIsErrorModalVisible(true);
                                            } else {
                                              setYoutubeLinks(
                                                form?.getFieldValue(
                                                  "youtubelinks"
                                                )
                                              );
                                            }
                                            return true;
                                          });
                                      }}
                                      style={{ borderRadius: 8 }}
                                    >
                                      Update
                                    </Button>
                                  </>
                                );
                              }}
                            </Form.List>
                          </Col>
                        </Row>
                      </Panel>
                    ) : null}
                    <Panel header="Social Links" key={7}>
                      <Row xs={12} md={24} align="center" style={{ gap: 15 }}>
                        {/* Facebook */}
                        <div
                          onClick={() => setIsFacebook(!isFacebook)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isFacebook ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RiFacebookBoxFill
                            color={isFacebook ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>
                        {/* Instagram */}
                        <div
                          onClick={() => setIsInstagram(!isInstagram)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isInstagram ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RiInstagramFill
                            color={isInstagram ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>
                        {/* linkedin */}
                        <div
                          onClick={() => setIsLinkedin(!isLinkedin)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isLinkedin ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RiLinkedinBoxFill
                            color={isLinkedin ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>
                        {/* Twitter */}
                        <div
                          onClick={() => setIsTwitter(!isTwitter)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isTwitter ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RiTwitterFill
                            color={isTwitter ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>
                        {/* Skype */}
                        <div
                          onClick={() => setIsSkype(!isSkype)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isSkype ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RiSkypeFill
                            color={isSkype ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>
                        {/* Behance */}
                        <div
                          onClick={() => setIsBehance(!isBehance)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isBehance ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RiBehanceFill
                            color={isBehance ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>
                        {/* Youtube */}
                        <div
                          onClick={() => setIsYoutube(!isYoutube)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isYoutube ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RiYoutubeFill
                            color={isYoutube ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>
                      </Row>
                      <Row
                        xs={12}
                        md={24}
                        align="center"
                        style={{ gap: 15, marginTop: 15 }}
                      >
                        {/* Whatsapp */}
                        <div
                          onClick={() => setIsWhatsapp(!isWhatsapp)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isWhatsapp ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RiWhatsappFill
                            color={isWhatsapp ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>
                        {/* Maps */}
                        <div
                          onClick={() => setIsMaps(!isMaps)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isMaps ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RiMap2Fill
                            color={isMaps ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>

                        {/* Mail */}
                        <div
                          onClick={() => setIsMail(!isMail)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isMail ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RiMailFill
                            color={isMail ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>
                        {/* Telegram */}
                        <div
                          onClick={() => setIsTelegram(!isTelegram)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isTelegram ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RiTelegramFill
                            color={isTelegram ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>
                        {/* Tiktok */}
                        <div
                          onClick={() => setIsTiktok(!isTiktok)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isTiktok ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <FaTiktok
                            color={isTiktok ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>
                        {/* Snapchat */}
                        <div
                          onClick={() => setIsSnapchat(!isSnapchat)}
                          style={{
                            cursor: "pointer",
                            width: 60,
                            height: 60,
                            borderRadius: 30,
                            border: `1px solid ${
                              isSnapchat ? primaryDark : "lightgray"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <RiSnapchatFill
                            color={isSnapchat ? primaryDark : "lightgray"}
                            style={{ fontSize: 30 }}
                          />
                        </div>
                      </Row>
                      {/* Social Inputs */}
                      <Col xs={24} md={24} style={{ marginTop: 15 }}>
                        {isFacebook && (
                          <Item
                            name="facebook"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="facebook"
                              style={{ borderRadius: 8 }}
                              placeholder="yourpage"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() => {
                                    const linkValue =
                                      form.getFieldValue("facebook");
                                    const link = linkValue.includes(
                                      "facebook.com/"
                                    )
                                      ? linkValue.split("facebook.com/")[1]
                                      : linkValue;
                                    const finalLink =
                                      "https://www.facebook.com/" + link;
                                    window.open(finalLink, "_blank");
                                  }}
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <RiFacebookBoxFill
                                    color="lightgray"
                                    style={{
                                      fontSize: 30,
                                      marginRight: 10,
                                    }}
                                  />
                                  {!form.getFieldValue("facebook") &&
                                    "facebook.com/"}
                                </>
                              }
                            />
                          </Item>
                        )}
                        {isInstagram && (
                          <Item
                            name="instagram"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="instagram"
                              style={{ borderRadius: 8 }}
                              placeholder="yourpage"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() => {
                                    const linkValue =
                                      form.getFieldValue("instagram");
                                    const link = linkValue.includes(
                                      "instagram.com/"
                                    )
                                      ? linkValue.split("instagram.com/")[1]
                                      : linkValue;
                                    const finalLink =
                                      "https://www.instagram.com/" + link;
                                    window.open(finalLink, "_blank");
                                  }}
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <RiInstagramFill
                                    color="lightgray"
                                    style={{ fontSize: 30, marginRight: 10 }}
                                  />
                                  {!form.getFieldValue("instagram") &&
                                    "instagram.com/"}
                                </>
                              }
                            />
                          </Item>
                        )}
                        {isLinkedin && (
                          <Item
                            name="linkedin"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="linkedin"
                              style={{ borderRadius: 8 }}
                              placeholder="yourpage"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() => {
                                    const linkValue =
                                      form.getFieldValue("linkedin");
                                    const link = linkValue.includes(
                                      "linkedin.com/in/"
                                    )
                                      ? linkValue.split("linkedin.com/in/")[1]
                                      : linkValue;
                                    const finalLink =
                                      "https://www.linkedin.com/in/" + link;
                                    window.open(finalLink, "_blank");
                                  }}
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <RiLinkedinBoxFill
                                    color="lightgray"
                                    style={{ fontSize: 30, marginRight: 10 }}
                                  />
                                  {!form.getFieldValue("linkedin") &&
                                    "linkedin.com/in/"}
                                </>
                              }
                            />
                          </Item>
                        )}
                        {isTwitter && (
                          <Item
                            name="twitter"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="twitter"
                              style={{ borderRadius: 8 }}
                              placeholder="yourpage"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() => {
                                    const linkValue =
                                      form.getFieldValue("twitter");
                                    const link = linkValue.includes(
                                      "twitter.com/"
                                    )
                                      ? linkValue.split("twitter.com/")[1]
                                      : linkValue;
                                    const finalLink =
                                      "https://www.twitter.com/" + link;
                                    window.open(finalLink, "_blank");
                                  }}
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <RiTwitterFill
                                    color="lightgray"
                                    style={{ fontSize: 30, marginRight: 10 }}
                                  />
                                  {!form.getFieldValue("twitter") &&
                                    "twitter.com/"}
                                </>
                              }
                            />
                          </Item>
                        )}
                        {isSkype && (
                          <Item
                            name="skype"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="skype"
                              style={{ borderRadius: 8 }}
                              placeholder="Skype Id"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() => {
                                    const linkValue =
                                      form.getFieldValue("skype");
                                    const link = linkValue.includes(
                                      "skype.com/"
                                    )
                                      ? linkValue.split("skype.com/")[1]
                                      : linkValue;
                                    const finalLink =
                                      "https://www.skype.com/" + link;
                                    window.open(finalLink, "_blank");
                                  }}
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <RiSkypeFill
                                    color="lightgray"
                                    style={{ fontSize: 30, marginRight: 10 }}
                                  />
                                  {!form.getFieldValue("skype") && "skype.com/"}
                                </>
                              }
                            />
                          </Item>
                        )}
                        {isBehance && (
                          <Item
                            name="behance"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="behance"
                              style={{ borderRadius: 8 }}
                              placeholder="yourpage"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() => {
                                    const linkValue =
                                      form.getFieldValue("behance");
                                    const link = linkValue.includes(
                                      "behance.com/"
                                    )
                                      ? linkValue.split("behance.com/")[1]
                                      : linkValue;
                                    const finalLink =
                                      "https://www.behance.com/" + link;
                                    window.open(finalLink, "_blank");
                                  }}
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <RiBehanceFill
                                    color="lightgray"
                                    style={{ fontSize: 30, marginRight: 10 }}
                                  />
                                  {!form.getFieldValue("behance") &&
                                    "behance.com/"}
                                </>
                              }
                            />
                          </Item>
                        )}
                        {isYoutube && (
                          <Item
                            name="youtube"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="youtube"
                              style={{ borderRadius: 8 }}
                              placeholder="yourpage"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() => {
                                    const linkValue =
                                      form.getFieldValue("youtube");
                                    let link =
                                      linkValue.split("youtube.com")[1];
                                    link = "www.youtube.com" + link;
                                    window.open(link, "_blank");
                                  }}
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <RiYoutubeFill
                                    color="lightgray"
                                    style={{ fontSize: 30, marginRight: 10 }}
                                  />
                                  {!form.getFieldValue("youtube") &&
                                    "youtube.com/"}
                                </>
                              }
                            />
                          </Item>
                        )}
                        {isWhatsapp && (
                          <Item
                            name="whatsapp"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="whatsapp"
                              style={{ borderRadius: 8 }}
                              placeholder="phonenumber"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() => {
                                    const linkValue =
                                      form.getFieldValue("whatsapp");
                                    const link = linkValue.includes("wa.me/")
                                      ? linkValue.split("wa.me/")[1]
                                      : linkValue;
                                    const finalLink =
                                      "https://www.wa.me/" + link;
                                    window.open(finalLink, "_blank");
                                  }}
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <RiWhatsappFill
                                    color="lightgray"
                                    style={{ fontSize: 30, marginRight: 10 }}
                                  />
                                  {!form.getFieldValue("whatsapp") && "wa.me/"}
                                </>
                              }
                            />
                          </Item>
                        )}
                        {isMaps && (
                          <Item
                            name="maps"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="maps"
                              style={{ borderRadius: 8 }}
                              placeholder="id"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() => {
                                    const linkValue =
                                      form.getFieldValue("maps");
                                    const link = linkValue.includes(
                                      "goo.gl/maps"
                                    )
                                      ? linkValue.split("goo.gl/maps/")[1]
                                      : linkValue;
                                    const finalLink =
                                      "https://goo.gl/maps/" + link;
                                    window.open(finalLink, "_blank");
                                  }}
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <RiMap2Fill
                                    color="lightgray"
                                    style={{ fontSize: 30, marginRight: 10 }}
                                  />
                                  {!form.getFieldValue("maps") &&
                                    "goo.gl/maps/"}
                                </>
                              }
                            />
                          </Item>
                        )}
                        {isMail && (
                          <Item
                            name="mail"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="mail"
                              style={{ borderRadius: 8 }}
                              placeholder="xyz@domain.com"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() =>
                                    window.open(
                                      form.getFieldValue("mail"),
                                      "_blank"
                                    )
                                  }
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <RiMailFill
                                    color="lightgray"
                                    style={{
                                      fontSize: 30,
                                      marginRight: 10,
                                    }}
                                  />
                                </>
                              }
                            />
                          </Item>
                        )}
                        {isTelegram && (
                          <Item
                            name="telegram"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="telegram"
                              style={{ borderRadius: 8 }}
                              placeholder="username"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() => {
                                    const linkValue =
                                      form.getFieldValue("telegram");
                                    const link = linkValue.includes("t.me/")
                                      ? linkValue.split("t.me/")[1]
                                      : linkValue;
                                    const finalLink = "https://t.me/" + link;
                                    window.open(finalLink, "_blank");
                                  }}
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <RiTelegramFill
                                    color="lightgray"
                                    style={{ fontSize: 30, marginRight: 10 }}
                                  />
                                  {!form.getFieldValue("telegram") && "t.me/"}
                                </>
                              }
                            />
                          </Item>
                        )}
                        {isTiktok && (
                          <Item
                            name="tiktok"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="tiktok"
                              style={{ borderRadius: 8 }}
                              placeholder="usename"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() => {
                                    const linkValue =
                                      form.getFieldValue("tiktok");
                                    const link = linkValue.includes(
                                      "vt.tiktok.com/"
                                    )
                                      ? linkValue.split("vt.tiktok.com/")[1]
                                      : linkValue;
                                    const finalLink =
                                      "https://vt.tiktok.com/" + link;
                                    window.open(finalLink, "_blank");
                                  }}
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <FaTiktok
                                    color="lightgray"
                                    style={{ fontSize: 30, marginRight: 10 }}
                                  />
                                  {!form.getFieldValue("tiktok") &&
                                    "vt.tiktok.com/"}
                                </>
                              }
                            />
                          </Item>
                        )}
                        {isSnapchat && (
                          <Item
                            name="snapchat"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <Input
                              size="large"
                              name="snapchat"
                              style={{ borderRadius: 8 }}
                              placeholder="username"
                              suffix={
                                <Button
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: 8,
                                  }}
                                  icon={
                                    <FiExternalLink
                                      style={{ marginRight: 5 }}
                                    />
                                  }
                                  onClick={() => {
                                    const linkValue =
                                      form.getFieldValue("snapchat");
                                    const link = linkValue.includes(
                                      "snapchat.com/add/"
                                    )
                                      ? linkValue.split("snapchat.com/add/")[1]
                                      : linkValue;
                                    const finalLink =
                                      "https://www.snapchat.com/add/" + link;
                                    window.open(finalLink, "_blank");
                                  }}
                                >
                                  Test
                                </Button>
                              }
                              prefix={
                                <>
                                  <RiSnapchatFill
                                    color="lightgray"
                                    style={{ fontSize: 30, marginRight: 10 }}
                                  />
                                  {!form.getFieldValue("snapchat") &&
                                    "snapchat.com/add/"}
                                </>
                              }
                            />
                          </Item>
                        )}
                      </Col>
                    </Panel>
                    <Panel
                      header={
                        role === WHITE_LABEL_ADMIN
                          ? "Code Styles"
                          : "Wave Code Styles"
                      }
                      key={8}
                    >
                      <span
                        onClick={() => {
                          setPPicker(false);
                          setSPicker(false);
                        }}
                      >
                        <Row
                          gutter={10}
                          style={{ marginTop: 24, justifyContent: "center" }}
                        >
                          <Col xs={12} md={4}>
                            <h4>Show Qr code in profile</h4>
                          </Col>
                          <Col xs={12} md={20}>
                            <Switch
                              checked={showQr}
                              onChange={(e) => {
                                setShowQr(e);
                              }}
                            />
                          </Col>
                        </Row>
                        <Row span={24} justify="space-between">
                          <Col lg={24} xl={14}>
                            <Item name="color">
                              {/* color picker */}
                              <Row span={24} style={{ marginTop: 24 }}>
                                <Col xs={24} md={4}>
                                  <h4>Select Colors</h4>
                                </Col>
                                <Col xs={24} md={9} className="ecLevel">
                                  <Input
                                    onChange={(e) =>
                                      setQrSettings({
                                        ...qrSettings,
                                        fgColor: e.target.value,
                                      })
                                    }
                                    size="large"
                                    prefix={
                                      <>
                                        <CgColorPicker
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setPPicker(!pPicker);
                                          }}
                                          style={{
                                            background: qrSettings?.fgColor,
                                            color: "lightgray",
                                            border: "1px solid lightgray",
                                            width: 30,
                                            padding: 5,
                                            height: "100%",
                                            borderRadius: 8,
                                          }}
                                        />

                                        {pPicker && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: -350,
                                            }}
                                          >
                                            <SketchPicker
                                              color={qrSettings.fgColor}
                                              onChange={(e) =>
                                                setQrSettings({
                                                  ...qrSettings,
                                                  fgColor: `rgba(${e.rgb.r},${e.rgb.g},${e.rgb.b},${e.rgb.a})`,
                                                })
                                              }
                                            />
                                          </div>
                                        )}
                                      </>
                                    }
                                    style={{ borderRadius: 8 }}
                                    value={qrSettings.fgColor}
                                  />
                                </Col>
                                <Col xs={24} md={9} className="ecLevel">
                                  <Input
                                    onChange={(e) =>
                                      setQrSettings({
                                        ...qrSettings,
                                        bgColor: e.target.value,
                                      })
                                    }
                                    size="large"
                                    prefix={
                                      <>
                                        <CgColorPicker
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSPicker(!sPicker);
                                          }}
                                          style={{
                                            background: qrSettings.bgColor,
                                            color: "lightgray",
                                            border: "1px solid lightgray",
                                            width: 30,
                                            padding: 5,
                                            height: "100%",
                                            borderRadius: 8,
                                          }}
                                        />

                                        {sPicker && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: -350,
                                            }}
                                          >
                                            <SketchPicker
                                              color={qrSettings.bgColor}
                                              onChange={(e) => {
                                                setQrSettings({
                                                  ...qrSettings,
                                                  bgColor: `rgba(${e.rgb.r},${e.rgb.g},${e.rgb.b},${e.rgb.a})`,
                                                });
                                              }}
                                            />
                                          </div>
                                        )}
                                      </>
                                    }
                                    style={{ borderRadius: 8 }}
                                    value={qrSettings.bgColor}
                                  />
                                </Col>
                              </Row>
                            </Item>
                            <Row span={24} style={{ marginTop: 24 }}>
                              <Col xs={12} md={4}>
                                <h4>EC Level</h4>
                                <p style={{ fontSize: 10, color: "lightgray" }}>
                                  *Error Correction
                                </p>
                              </Col>
                              <Col xs={12} md={20}>
                                <Radio.Group
                                  value={qrSettings.ecLevel}
                                  onChange={(e) =>
                                    setQrSettings({
                                      ...qrSettings,
                                      ecLevel: e.target.value,
                                    })
                                  }
                                >
                                  <Space
                                    wrap={true}
                                    style={{
                                      display: "flex",
                                    }}
                                  >
                                    <Radio.Button
                                      style={{ borderRadius: 8 }}
                                      value={"L"}
                                    >
                                      Low
                                    </Radio.Button>
                                    <Radio.Button
                                      style={{ borderRadius: 8 }}
                                      value={"M"}
                                    >
                                      Medium
                                    </Radio.Button>
                                    <Radio.Button
                                      style={{ borderRadius: 8 }}
                                      value={"Q"}
                                    >
                                      Quartile
                                    </Radio.Button>
                                    <Radio.Button
                                      style={{ borderRadius: 8 }}
                                      value={"H"}
                                    >
                                      High
                                    </Radio.Button>
                                  </Space>
                                </Radio.Group>
                              </Col>
                            </Row>
                            <Row gutter={10} style={{ marginTop: 24 }}>
                              <Col xs={12} md={4}>
                                <h4>Style</h4>
                              </Col>
                              <Col xs={12} md={20}>
                                <Radio.Group
                                  value={qrSettings.qrStyle}
                                  onChange={(e) =>
                                    setQrSettings({
                                      ...qrSettings,
                                      qrStyle: e.target.value,
                                    })
                                  }
                                >
                                  <Space
                                    style={{
                                      display: "flex",
                                    }}
                                    wrap={true}
                                  >
                                    <Radio.Button
                                      style={{ borderRadius: 8 }}
                                      value={"squares"}
                                    >
                                      Squares
                                    </Radio.Button>
                                    <Radio.Button
                                      style={{ borderRadius: 8 }}
                                      value={"dots"}
                                    >
                                      Dots
                                    </Radio.Button>
                                  </Space>
                                </Radio.Group>
                              </Col>
                            </Row>
                            <Row gutter={10} style={{ marginTop: 24 }}>
                              <Col xs={12} md={4}>
                                <h4>Eye Radius</h4>
                              </Col>
                              <Col xs={12} md={20}>
                                <Slider
                                  defaultValue={qrSettings.eyeRadius}
                                  max={50}
                                  value={qrSettings.eyeRadius}
                                  onChange={(e) =>
                                    setQrSettings({
                                      ...qrSettings,
                                      eyeRadius: e,
                                    })
                                  }
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col lg={24} xl={9}>
                            <QRCode
                              size={qrSettings.size}
                              value={`${
                                process.env.REACT_APP_DOMAIN_URL ||
                                "https://wavecodes.com.au"
                              }/wc/${link}`}
                              quietZone={qrSettings.quietZone}
                              fgColor={qrSettings.fgColor}
                              bgColor={qrSettings.bgColor}
                              ecLevel={qrSettings.ecLevel}
                              qrStyle={qrSettings.qrStyle}
                              eyeRadius={qrSettings.eyeRadius}
                              logoImage={qrSettings.logoImage}
                              logoWidth={qrSettings.logoWidth}
                              logoHeight={qrSettings.logoHeight}
                              logoOpacity={qrSettings.logoOpacity}
                              removeQrCodeBehindLogo={!!qrSettings?.logoImage}
                            />
                          </Col>
                        </Row>

                        <Row gutter={10} style={{ marginTop: 24 }}>
                          <Col xs={12} md={4}>
                            <h4>Logo Image</h4>
                            <p className="subText">Size: 500 KB</p>
                          </Col>
                          <Col xs={12} md={20}>
                            <ImgCrop
                              rotate
                              modalTitle="Crop Image  *Image previews can be blurred. It will not affect quality of image."
                              quality={1}
                              fillColor="#00000000"
                              aspect={2 / 1}
                            >
                              <Upload
                                className="fileList-upload-images"
                                maxCount={1}
                                customRequest={postLogoImage}
                                listType="picture-card"
                                fileList={logoImageList}
                                onPreview={handlePreview}
                                onRemove={(e) => handleImageRemove(e?.name)}
                                onChange={(e) => {
                                  setLogoImageList(
                                    logoImageList.filter(
                                      (f) => f.uid !== e?.file?.uid
                                    )
                                  );
                                  setQrSettings({
                                    ...qrSettings,
                                    logoImage: "",
                                  });
                                }}
                                // beforeUpload={(file) => {
                                //   // const isLt2M = file.size / 1024 / 1024 < 2;
                                //   const isLt2M = file.size / 1024 <= 500; //less than 500 KB

                                //   if (!isLt2M) {
                                //     file.flag = true;
                                //     message.error(
                                //       "Please upload image less than 500Kb"
                                //     );
                                //     return false;
                                //   }
                                //   return true;
                                // }}
                                accept="image/*"
                              >
                                {logoImageList.length === 1 ? null : (
                                  <PlusOutlined />
                                )}
                              </Upload>
                            </ImgCrop>
                          </Col>
                        </Row>
                        {qrSettings?.logoImage && (
                          <Row gutter={10} style={{ marginTop: 24 }}>
                            <Col span={4}>
                              <h4>Logo Width</h4>
                            </Col>
                            <Col span={10}>
                              <Slider
                                defaultValue={qrSettings.logoWidth}
                                max={150}
                                value={qrSettings.logoWidth}
                                onChange={(e) =>
                                  setQrSettings({ ...qrSettings, logoWidth: e })
                                }
                              />
                            </Col>
                          </Row>
                        )}
                        {qrSettings?.logoImage && (
                          <Row gutter={10} style={{ marginTop: 24 }}>
                            <Col span={4}>
                              <h4>Logo Height</h4>
                            </Col>
                            <Col span={10}>
                              <Slider
                                defaultValue={qrSettings.logoHeight}
                                max={150}
                                value={qrSettings.logoHeight}
                                onChange={(e) =>
                                  setQrSettings({
                                    ...qrSettings,
                                    logoHeight: e,
                                  })
                                }
                              />
                            </Col>
                          </Row>
                        )}
                        {qrSettings?.logoImage && (
                          <Row gutter={10} style={{ marginTop: 24 }}>
                            <Col span={4}>
                              <h4>Logo Opacity</h4>
                            </Col>
                            <Col span={10}>
                              <Slider
                                defaultValue={qrSettings.logoOpacity}
                                max={40}
                                min={0}
                                step={0.1}
                                value={qrSettings.logoOpacity}
                                onChange={(e) =>
                                  setQrSettings({
                                    ...qrSettings,
                                    logoOpacity: e,
                                  })
                                }
                              />
                            </Col>
                          </Row>
                        )}
                      </span>
                    </Panel>
                  </Collapse>

                  <Item style={{ textAlign: "right" }}>
                    {[SUB_ADMIN, ADMIN, EDITOR_ADMIN, ACTING_ADMIN].includes(
                      role
                    ) && (
                      <AddWalletButton
                        size="large"
                        vCard={qrData}
                        style={{
                          fontWeight: "500",
                          paddingLeft: 30,
                          paddingRight: 30,
                          marginRight: 10,
                        }}
                        loading={isEditting}
                      ></AddWalletButton>
                    )}
                    <Button
                      loading={isEditting}
                      type="primary"
                      shape="round"
                      size="large"
                      htmlType="submit"
                      style={{
                        paddingLeft: 30,
                        paddingRight: 30,
                        textTransform: "uppercase",
                        margin: ".5rem 0",
                        background: primaryDark,
                        borderColor: primaryDark,
                        fontWeight: "500",
                        marginLeft: "1rem",
                      }}
                    >
                      Save Changes
                    </Button>
                  </Item>
                </Form>
              </Col>
            </Row>
          </Col>
          <Col span={8} className="subContainer">
            <Collapse
              defaultActiveKey={["1"]}
              bordered={false}
              className="site-collapse-custom-panel"
              expandIcon={({ isActive }) => (
                <DoubleRightOutlined rotate={isActive ? 90 : 0} />
              )}
            >
              <Panel header="Preview" key={1}>
                <div>
                  <PreviewVcard
                    selectedTheme={selectedTheme}
                    primaryColor={colors?.primary}
                    secondaryColor={colors?.secondary}
                    bgImage={bgImage}
                    profileImage={profileImage}
                    fName={basicInfo.fName}
                    fNamePrefix={basicInfo.fNamePrefix}
                    lName={basicInfo.lName}
                    lNameSuffix={basicInfo.lNameSuffix}
                    mobile={basicInfo.mobile}
                    mobile2={basicInfo.mobile2}
                    phone={basicInfo.phone}
                    phone2={basicInfo.phone2}
                    email={basicInfo.email}
                    email2={basicInfo.email2}
                    jobTitle={basicInfo.jobTitle}
                    company={basicInfo.company}
                    address={basicInfo.address}
                    postalAddress={basicInfo.postalAddress}
                    link={link}
                    summary={basicInfo.summary}
                    webLinks={finalWebSites}
                    images={fileList}
                    socialLinks={socialLinks}
                    qrSetting={qrSettings}
                    showQr={showQr}
                    youtubeLinks={youtubeLinks}
                    sectionOrder={sectionOrder}
                    setSectionOrder={setSectionOrder}
                  />
                </div>
              </Panel>
              <Panel
                header={role === WHITE_LABEL_ADMIN ? "Code" : "WaveCode"}
                key={2}
              >
                <Row>
                  <Col
                    span={24}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <QRCode
                      size={qrSettings.size}
                      value={`${
                        process.env.REACT_APP_DOMAIN_URL ||
                        "https://wavecodes.com.au"
                      }/wc/${link}`}
                      quietZone={qrSettings.quietZone}
                      fgColor={qrSettings.fgColor}
                      bgColor={qrSettings.bgColor}
                      ecLevel={qrSettings.ecLevel}
                      qrStyle={qrSettings.qrStyle}
                      eyeRadius={qrSettings.eyeRadius}
                      logoImage={qrSettings.logoImage}
                      logoWidth={qrSettings.logoWidth}
                      logoHeight={qrSettings.logoHeight}
                      logoOpacity={qrSettings.logoOpacity}
                    />
                    <Link target="_blank" to={`/wc/${link}`}>
                      {link}
                    </Link>
                    <Button
                      block
                      size="large"
                      type="primary"
                      shape="round"
                      style={{
                        marginTop: 24,

                        background: primaryDark,
                        borderColor: primaryDark,
                        fontWeight: "500",
                      }}
                      onClick={handleDownloadQR}
                    >
                      Download Wave Code
                    </Button>
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      )}
      {/* Choose Icon */}
      <Modal
        style={{ borderRadius: 13 }}
        bodyStyle={{ paddingLeft: "2rem", paddingRight: "2rem" }}
        visible={!!iconModal}
        title="Choose Weblink Icon"
        footer={null}
        onCancel={() => setIconModal("")}
      >
        <Search
          placeholder="Search Icon"
          onSearch={() => {
            handleSearchIcon();
          }}
          value={searchIconValue}
          onChange={(e) => {
            setSearchIconValue(e.target.value);
          }}
          enterButton
        />
        <div style={{ marginTop: "1rem", padding: "1rem" }}>
          {searchedIcon?.length > 0 ? (
            <Space wrap={true}>
              {searchedIcon?.slice(0, 20).map((icon) => (
                <i
                  onClick={() => {
                    handleAddIcon(iconModal, icon);
                  }}
                  key={icon}
                  className={`fas fa-${icon} fa-2x`}
                  style={{ margin: "1rem", cursor: "pointer" }}
                />
              ))}
            </Space>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <p>
                {searchIconValue.length > 0 ? "No Icon Found" : "Search Icon"}
              </p>

              <p
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  marginTop: ".5rem",
                  marginBottom: ".5rem",
                }}
              >
                OR
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <p>Upload Custom Icon</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <ImgCrop
                    rotate
                    modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
                    quality={1}
                    shape="rect"
                    // minZoom={1}
                    // maxZoom={10}
                    // aspect={2 / 1}
                    // modalWidth={530}
                    fillColor="#00000000"
                  >
                    <Upload
                      className="fileList-upload-images"
                      maxCount={1}
                      customRequest={(e) => {
                        handleAddCustomIcon(e, iconModal);
                      }}
                      fileList={[]}
                      listType="picture-card"
                      onPreview={handlePreview}
                      onRemove={(e) => handleImageRemove(e?.name)}
                      onChange={(e) => {}}
                      accept="image/png"
                    >
                      <PlusOutlined />
                    </Upload>
                  </ImgCrop>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal>
      <Modal
        style={{ borderRadius: 13 }}
        bodyStyle={{ padding: 10 }}
        visible={previewVisible}
        title="Image Preview"
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
      {/* Form Failed Modal */}
      <Modal
        title="Input Required"
        visible={isErrorModalVisible}
        footer={null}
        onCancel={() => setIsErrorModalVisible(false)}
      >
        <div style={{ textAlign: "center" }}>
          <p style={{ color: danger }}>
            Please Check and fill the mandatory fields to proceed
          </p>
          <Button
            shape="round"
            type="primary"
            style={{
              background: primaryDark,
              borderColor: primaryDark,
            }}
            onClick={() => setIsErrorModalVisible(false)}
          >
            Close
          </Button>
        </div>
      </Modal>
      {!!profileManagementModal && (
        <ProfileManagementModal
          profileManagementModal={profileManagementModal}
          setProfileManagementModal={setProfileManagementModal}
          profiles={profiles}
          qrLink={id}
          getQrCode={getQrCode}
          selectedProfileId={selectedProfileId}
          setShowSetupProfileModal={setShowSetupProfileModal}
        />
      )}
      {!!showSetupProfileModal && (
        <SetupProfileModal
          showSetupProfileModal={showSetupProfileModal}
          setShowSetupProfileModal={setShowSetupProfileModal}
          qrLink={id}
          getQrCode={getQrCode}
          setProfileManagementModal={setProfileManagementModal}
        />
      )}
    </Layout>
  );
};

export default EditQrCode;
